import { createSelector } from '@ngrx/store';
import { selectFilterState } from '../filter.selectors';
import { FilterState } from '@immosky/types';

export const selectCategoryFilterState = createSelector(
  selectFilterState,
  (state: FilterState) => state.category
);

export const selectMainCategoryFilter = createSelector(
  selectCategoryFilterState,
  (filterState) => filterState.main
);

export const selectSubcategoryFilter = createSelector(
  selectCategoryFilterState,
  (filterState) => filterState.sub
);

export const selectAppliedSubcategoryCount = createSelector(
  selectCategoryFilterState,
  (filterState) => {
    let count = 0;
    const subcategoryOptions =
      filterState.sub.filter[filterState.main.filter.value];

    if (subcategoryOptions) {
      for (const option of subcategoryOptions) {
        if (option.isChecked) {
          count++;
        }
      }
    }

    return count;
  }
);
